export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const IS_PRODUCTION = import.meta.env.VITE_PRODUCTION === '1';
export const IS_STAGING = import.meta.env.VITE_STAGING === '1';
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENV = import.meta.env.VITE_SENTRY_ENV;
export const SENTRY_TRACES_SAMPLE = import.meta.env.VITE_SENTRY_TRACES_SAMPLE;